export enum ImageType {
  UPLOAD = "upload",
  PRODUCT = "product",
}
